import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=23a2d8bc&scoped=true&"
import script from "./CustomSelect.vue?vue&type=script&lang=ts&"
export * from "./CustomSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=23a2d8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a2d8bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
